export const registerServiceWorker = () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
        .then(() => console.log('SW registered'))
        .catch(console.error);

}